import React, {Component} from 'react';
import Scene from '../Scene.js'

class Toolbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    resetView(){
        Scene.resetZoom();
    }
    hidePart(e){
        var part = e.target.children[0].id;
        this.props.hideParts(part);
    }
    showRight() {
        Scene.changeView({x: -15, y: 0, z: 0});
    }
    showLeft(){
        Scene.changeView({x: 15, y: 0, z: 0});

    }
    render() {
        return (
            <div className="toolbar">
                    <div>
                        <button
                            style={{ margin: "2px" }}
                            className="btn btn-sm btn-secondary"
                            id="top"
                            onClick={this.props.viewTop}
                        >
                            <i className="fa fa-arrow-up" />
                        </button>
                    </div>
                    <div>
                        <button
                            style={{ margin: "2px" }}
                            className="btn btn-sm btn-secondary"
                            id="left"
                            onClick={this.props.viewLeft}
                        >
                            <i className="fa fa-arrow-left" />
                        </button>
                        <button
                            style={{ margin: "2px" }}
                            className="btn btn-sm btn-secondary"
                            id="home"
                            onClick={this.props.resetView}
                        >
                            <i className="fa fa-bars" />
                        </button>
                        <button
                            style={{ margin: "2px" }}
                            className="btn btn-sm btn-secondary"
                            id="right"
                            onClick={this.props.viewRight}
                        >
                            <i className="fa fa-arrow-right" />
                        </button>
                    </div>
                    <div>
                        <button
                            style={{ margin: "2px" }}
                            className="btn btn-sm btn-secondary"
                            id="down"
                            onClick={this.props.viewBottom}
                        >
                            <i className="fa fa-arrow-down" />
                        </button>
                    </div>
            </div>

        )
    }
}
export default Toolbar;


// WEBPACK FOOTER //
// ./resources/assets/js/components/viewer/Toolbar.jsx